import React, { useState } from 'react';
import { MenuDivider, MenuItemOption, MenuItem, MenuList, MenuOptionGroup, MenuGroup, Box, } from '@chakra-ui/react';
import { useTokens } from '../../../context/TokenProvider';
import { localise } from '../../../services/lang/lang';
const MultiSelect = ({ filterLabel, groups, onApply, }) => {
    const tokens = useTokens();
    const filterStyles = {
        applyButton: {
            background: 'white',
            color: tokens.ButtonTertiaryButtonTertiaryText,
            borderColor: tokens.ButtonTertiaryButtonTertiaryBorder,
            borderWidth: tokens.BorderWidth01,
            borderRadius: tokens.BorderRadius02,
            margin: '0 8px',
            justifyContent: 'center',
            width: 'calc(100% - 16px)',
            textAlign: 'center',
            paddingTop: '10px',
            paddingBottom: '10px',
            _focus: {
                background: tokens.ButtonTertiaryButtonTertiaryBorder,
                color: 'white',
            },
            _hover: {
                background: tokens.ButtonTertiaryButtonTertiaryBorder,
                color: 'white',
            },
        },
        menuList: {
            div: {
                maxH: '500px',
                overflow: 'auto',
            },
        },
    };
    const [groupState, setGroupState] = useState(groups);
    const getValuesFromGroupState = () => Array.from(new Set(groupState.flatMap((group) => group.selectedValues)));
    return (React.createElement(MenuList, { as: "ul", sx: filterStyles.menuList },
        groups.map((group, index) => (React.createElement(Box, { key: `menu_option_group_${index}` },
            React.createElement(MenuOptionGroup, { type: "checkbox", onChange: (updatedValues) => {
                    groupState[index].selectedValues = updatedValues;
                    setGroupState(groupState);
                }, defaultValue: groupState[index].selectedValues, title: group.title }, group.items.map((item) => (React.createElement(MenuItemOption, { as: "li", key: `menu_item_${item.title}`, isDisabled: item.isDisabled, value: item.value }, item.title)))),
            React.createElement(MenuDivider, null)))),
        React.createElement(MenuGroup, null,
            React.createElement(MenuItem, { sx: filterStyles.applyButton, tabIndex: 0, role: "button", "aria-label": filterLabel, "data-testid": "multi_select__apply_button", onClick: () => onApply(getValuesFromGroupState()) }, localise('APPLY')))));
};
export default MultiSelect;
